import {useRef} from 'react';
import {useScroll} from 'react-use';
import {Button, Text} from '~/components';
import {DATA_TEST_IDS} from '~/lib/const';

export function CartEmpty({
  onClose,
  layout = 'drawer',
}: {
  onClose?: () => void;
  layout?: 'page' | 'drawer';
}) {
  const scrollRef = useRef(null);
  const {y} = useScroll(scrollRef);

  const container = {
    drawer: `grid content-start gap-4 px-6 pb-8 transition overflow-y-scroll md:gap-12 md:px-12 h-screen-no-nav md:pb-12 mt-5 ${
      y > 0 ? 'border-t' : ''
    }`,
    page: `grid pb-12 w-full md:items-start gap-4 md:gap-8 lg:gap-12`,
  };

  return (
    <div
      data-testid={DATA_TEST_IDS.CART_EMPTY}
      ref={scrollRef}
      className={container[layout]}
    >
      <section className="grid gap-6">
        <Text>
          Looks like you haven&rsquo;t added anything yet, let&rsquo;s get you
          started!
        </Text>
        <div>
          <Button
            data-testid={DATA_TEST_IDS.BUTTON('continue-shopping')}
            onClick={onClose}
          >
            CONTINUE SHOPPING
          </Button>
        </div>
      </section>
    </div>
  );
}
